// deps
import React from "react";

// styles
import { CartGroupHeader, CartGroupHeaderTitle } from "../styles";

interface CartGroupTitleProps {
    title: string;
    "data-testid"?: string;
    headerClassName?: string;
}

function CartGroupTitle({
    title,
    "data-testid": dataTestId,
    headerClassName,
}: CartGroupTitleProps): React.ReactElement {
    return (
        <CartGroupHeader className={headerClassName}>
            <CartGroupHeaderTitle data-testid={dataTestId} variant={"V2.body1.neutral.bold"} asElement="h2">
                {title}
            </CartGroupHeaderTitle>
        </CartGroupHeader>
    );
}

export default CartGroupTitle;
